<template>
  <div>
    <LanguageSwitcher />
    <main>
      <router-view v-slot="{ Component }">
        <keep-alive>
          <suspense>
            <template #default>
              <div>
                <BrandedHeader />
                <div class="min-h-screen page-background px-4 pt-2 pb-8">
                  <component :is="Component" />
                </div>
              </div>
            </template>
            <template #fallback>
              <div class="flex justify-center items-center py-20">
                <div class="text-center">
                  <div class="mb-4 text-gray-500">Loading...</div>
                </div>
              </div>
            </template>
          </suspense>
        </keep-alive>
      </router-view>
    </main>
  </div>
</template>

<script setup lang="ts">
import { onMounted } from 'vue'
import { useRoute } from 'vue-router'
import { useBookingStore } from '@/stores/booking'
import LanguageSwitcher from '@/components/ui/LanguageSwitcher.vue'
import BrandedHeader from '@/components/booking/BrandedHeader.vue'

const route = useRoute()
const bookingStore = useBookingStore()

// Set placeId from URL query parameter
onMounted(() => {
  const placeId = route.query.placeId as string
  if (placeId) {
    console.log(`Setting placeId from URL: ${placeId}`)
    bookingStore.setPlaceId(placeId)
  } else {
    // Don't reset to default if we already have a placeId in the store
    // This preserves the placeId when refreshing pages that don't have it in the URL
    if (bookingStore.placeId === 'default') {
      console.log('No placeId in URL and no existing placeId in store, using default')
    } else {
      console.log('No placeId in URL, but keeping existing placeId:', bookingStore.placeId)
    }
  }
})
</script>